import { useEffect } from 'react';
import useLatest from 'use-latest';

// Fixing inconsistencies from older browsers
// https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
var aliases = new Map([['Win', 'Meta'], ['Scroll', 'ScrollLock'], ['Spacebar', ' '], ['Down', 'ArrowDown'], ['Left', 'ArrowLeft'], ['Right', 'ArrowRight'], ['Up', 'ArrowUp'], ['Del', 'Delete'], ['Crsel', 'CrSel'], ['Exsel', 'ExSel'], ['Apps', 'ContextMenu'], ['Esc', 'Escape'], ['Decimal', '.'], ['Multiply', '*'], ['Add', '+'], ['Subtract', '-'], ['Divide', '/']]);

var shimKeyboardEvent = function shimKeyboardEvent(event) {
  if (aliases.has(event.key)) {
    var key = aliases.get(event.key);
    Object.defineProperty(event, 'key', {
      configurable: true,
      enumerable: true,
      get: function get() {
        return key;
      }
    });
  }
};

var useKeypress = function useKeypress(keys, handler) {
  if (process.env.NODE_ENV !== 'production') {
    if (Array.isArray(keys)) {
      keys.forEach(function (key, i) {
        if (typeof key !== 'string') {
          throw new TypeError("Expected `keys[" + i + "]` to be of type `string`, but received type `" + typeof key + "`");
        }
      });
    } else if (typeof keys !== 'string') {
      throw new TypeError("Expected `keys` to be of type `array` or `string`, but received type `" + typeof keys + "`");
    }

    if (typeof handler !== 'function' && handler != null) {
      throw new TypeError("Expected `handler` to be of type `function`, but received type `" + typeof handler + "`");
    }
  }

  var keysRef = useLatest(keys);
  var handerRef = useLatest(handler);
  useEffect(function () {
    var handleKeydown = function handleKeydown(event) {
      shimKeyboardEvent(event);

      if (Array.isArray(keysRef.current) && keysRef.current.includes(event.key) || keysRef.current === event.key) {
        handerRef.current == null ? void 0 : handerRef.current(event);
      }
    };

    window.addEventListener('keydown', handleKeydown);
    return function () {
      window.removeEventListener('keydown', handleKeydown);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useKeypress;
//# sourceMappingURL=index.esm.js.map
